import { Button } from '@/components/ui/button';
import useOpenApiClient from '@/hooks/useOpenApiClient';
import { useReceiptFile } from '@/hooks/useReceiptFile';
import { useQuery } from '@tanstack/react-query';
import { Loader, X } from 'lucide-react';
import { Link, useParams } from 'wouter';

export function ViewReceiptImage() {
  const { receiptId } = useParams<'/receipts/:receiptId/view-image'>();
  const { apiFetch } = useOpenApiClient();

  const receiptsQuery = useQuery({
    queryKey: ['v1', 'receipts', receiptId],
    queryFn: () =>
      apiFetch.GET('/receipts/{receipt_id}', {
        params: {
          path: {
            receipt_id: receiptId,
          },
        },
      }),
    select: (data) => {
      return data.data?.data;
    },
    enabled: Boolean(receiptId),
  });

  const receiptFileQuery = useReceiptFile(receiptsQuery.data?.file_id);

  return (
    <div className="flex h-screen flex-col">
      <div className="bg-primary sticky top-0 flex items-center justify-center py-4">
        <h1 className="text-lg font-bold text-white">Receipt image</h1>
        <Link href={`/receipts/${receiptId}`} className="absolute right-2">
          <Button variant="ghost" size="icon" className="text-white hover:text-white/80">
            <X className="h-5 w-5" />
            <span className="sr-only">Close</span>
          </Button>
        </Link>
      </div>
      <div className="flex flex-1">
        {receiptFileQuery.isLoading ? (
          <div className="flex flex-1 items-center justify-center">
            <Loader />
          </div>
        ) : (
          receiptFileQuery.data && (
            <img src={receiptFileQuery.data.url} alt="Receipt" className="object-contain" />
          )
        )}
      </div>
    </div>
  );
}
